
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30380',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30380",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.54715",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8071",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11528",
  "I18n": "static-7.1633",
  "quartz": "static-1.7097",
  "quartz-config": "static-1.875",
  "quartz-core": "static-1.6316",
  "react-dlb": "static-1.80",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.804",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.54702",
  "feedback-utils": "static-1.54706",
  "forms-embed-utils-lib": "static-1.4518",
  "forms-utils-lib": "static-1.12683",
  "foundations-assets": "static-1.4924",
  "foundations-components": "static-1.8034",
  "foundations-theming": "static-1.4479",
  "hub-http": "static-1.6277",
  "hubspot-url-utils": "static-1.4132",
  "HubStyle": "static-2.11835",
  "icons": "static-2.650",
  "immutable": "static-2.79",
  "quick-fetch": "static-1.3959",
  "raven": "static-3.5925",
  "react": "static-7.187",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16733",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5385",
  "react-virtualized": "static-2.100",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.488",
  "tinymce-plugins": "static-1.57630",
  "transmute": "static-2.85",
  "ui-images": "static-2.1165",
  "UIComponents": "static-3.8474",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3441",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3374",
  "quartz-webpack": "static-1.3321",
  "foundations-theming-specialty": "static-1.2195",
  "property-description-translator": "static-1.3897",
  "HeadJS": "static-2.765",
  "framer-motion": "static-1.73",
  "hs-test-utils-bend-plugin": "static-1.3182",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.222",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4380",
  "jasmine-runner": "static-1.6518",
  "dispatcher": "static-1.137",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.839",
  "hubspotter-http": "static-1.4692",
  "mobile-manifest-mixins": "static-1.539",
  "module-federation": "static-1.24",
  "quartz-auth": "static-1.772",
  "quartz-head": "static-1.762",
  "quartz-i18n": "static-1.772",
  "quartz-routing": "static-1.527",
  "quartz-test": "static-1.772",
  "quartz-tracking": "static-1.476",
  "trellis-components": "static-1.2099",
  "ui-fonts": "static-1.790",
  "usage-tracker-container": "static-1.7394",
  "usage-tracker-core": "static-1.7254",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.157",
  "conversations-skeleton-state": "static-1.7303",
  "reference-resolvers": "static-1.8226",
  "sanitize-text": "static-1.8197",
  "PatternValidationJS": "static-1.437",
  "ReduxMessenger": "static-2.10419",
  "sanitize": "static-1.4531",
  "outpost": "static-1.4230",
  "rpc-client-utils": "static-1.4707",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4303",
  "floating-ui": "static-1.57",
  "hs-story-utils": "static-1.9478",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.31",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2080",
  "bend-plugin-foundations-theming": "static-1.2962",
  "foundations-theming-base": "static-1.3464",
  "stylex": "static-1.34",
  "hs-locale-management": "static-1.122",
  "csstype": "static-1.50",
  "web-vitals": "static-1.7",
  "ai-components-ui-library": "static-1.9100",
  "atom": "static-1.5129",
  "codemirror": "static-5.96",
  "content-assistance-lib": "static-1.7834",
  "ContentUtils": "static-1.68520",
  "data-token-picker": "static-1.16500",
  "file-manager-components": "static-1.23762",
  "FileManagerCore": "static-1.39261",
  "FileManagerLib": "static-1.39402",
  "frontend-preferences-client": "static-1.7981",
  "hub-http-contrib": "static-1.3096",
  "interframe": "static-3.4814",
  "layout-dnd-components": "static-1.12549",
  "layout-dnd-utils": "static-1.11524",
  "property-translator": "static-1.5453",
  "react-codemirror": "static-1.10682",
  "react-colorpicker": "static-2.10263",
  "reference-resolvers-lite": "static-1.8152",
  "rich-text-lib": "static-1.19919",
  "tinymce-data": "static-1.40601",
  "tinymce-themes": "static-1.56486",
  "ui-addon-emoji-picker": "static-1.9941",
  "ui-addon-sales-email": "static-1.5265",
  "ui-brand-identity-lib": "static-1.15487",
  "bender-build-tools": "static-1.3254",
  "hub-http-shared-msw-handlers": "static-1.10091",
  "hubspotter-http-shared-msw-handlers": "static-1.10089",
  "usage-tracker-session-replay": "static-1.5090",
  "base-ui": "static-1.12",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.988",
  "tanstack-virtual": "static-1.31",
  "react-immutable-proptypes": "static-2.8",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.117",
  "chirp-fetch": "static-1.1942",
  "chatspot-core": "static-1.21532",
  "copilot-toolkit": "static-1.11275",
  "customer-data-objects-ui-components": "static-1.13087",
  "data-fetching-client": "static-1.9719",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4815",
  "ui-addon-video-player": "static-1.8758",
  "ui-coaching-tips": "static-1.28707",
  "usage-tracker": "static-1.7404",
  "cms-field-types": "static-1.4867",
  "content-icons-ui": "static-1.2239",
  "integrations-lib": "static-1.16333",
  "customer-data-objects": "static-1.7732",
  "apollo-dlb": "static-3.86",
  "apollo-link-hub-http": "static-2.4706",
  "apollo-stack-hubspot": "static-3.87",
  "graphql": "static-1.83",
  "immer": "static-1.33",
  "immerable": "static-1.4208",
  "ui-addon-iframeable": "static-1.9115",
  "video-components-external": "static-1.11465",
  "video-data-lib": "static-1.35123",
  "audio-components": "static-1.5993",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29395",
  "FileManagerImages": "static-1.36913",
  "foundations-components-legacy": "static-1.1059",
  "html-to-image": "static-1.55",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "salesImages": "static-1.526",
  "ui-universal-auth": "static-1.9044",
  "urlinator": "static-1.4592",
  "video-components": "static-1.13467",
  "video-embed": "static-1.35957",
  "ts-schema": "static-1.4121",
  "ContentData": "static-1.68595",
  "layout-data-lib": "static-1.9849",
  "react-dnd-compat": "static-1.4668",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1596",
  "external-options-client-types": "static-1.4199",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.6943",
  "hs-promise-utils": "static-1.5646",
  "inbound-db-properties-service-client": "static-1.3886",
  "NamespacedHubStyle": "static-2.9100",
  "growth-onboarding-confetti": "static-1.3121",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11206",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.840",
  "magpie-lib": "static-1.5587",
  "magpie-types": "static-1.5047",
  "simple-logging-lib": "static-1.3105",
  "avatar-components": "static-1.2553",
  "customer-data-ui-utilities": "static-1.9880",
  "growth-onboarding-feedback-components": "static-1.6634",
  "flux-actions": "static-1.341",
  "hubspot-apollo-client": "static-1.4932",
  "integrations-error-boundary-lib": "static-1.13748",
  "integrations-tracking-lib": "static-1.5659",
  "laboratory-lib": "static-3.7210",
  "native-integrations-shared-strings": "static-1.7836",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10266",
  "unified-auth": "static-1.558",
  "navigation-messaging": "static-1.7493",
  "content-media-composition-data-lib": "static-1.12532",
  "content-media-compositions": "static-2.16539",
  "idb-keyval": "static-1.45",
  "media-bridge-lib": "static-1.19017",
  "unified-auth-core-lib": "static-1.840",
  "social-insights-client-types": "static-1.22240",
  "advanced-menus-core": "static-1.15212",
  "advanced-menus-lib": "static-1.12147",
  "ExportDialog": "static-6.10440",
  "ui-memberships-settings-lib": "static-1.34189",
  "conditional-properties-service-client": "static-1.3839",
  "crm-pipelines-api-client-types": "static-1.4181",
  "fdsr-migration-layer": "static-1.62",
  "framework-builder-read-service-client": "static-1.4046",
  "framework-data-schema-quick-fetch": "static-1.6848",
  "inbound-db-meta-service-client": "static-1.3627",
  "multi-currency-client-types": "static-1.3733",
  "persist-promise": "static-1.3753",
  "foundations-components-test-utils": "static-1.5517",
  "breeze-engine-core": "static-1.118",
  "ably": "static-2.2",
  "highlight.js": "static-1.80",
  "reactive-lib": "static-1.778",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.391",
  "universal-page-editor-lib": "static-1.3072",
  "ads-unified-auth-lib": "static-1.52",
  "google-sheets-integration-lib": "static-1.390",
  "microsoft-drive-integration-lib": "static-1.525",
  "slack-ui-library": "static-1.10446",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3785",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15211",
  "simple-menus-lib": "static-1.16728",
  "crm-record-cards-service-types": "static-1.3631",
  "location-customization-utils-lib": "static-1.9413",
  "react-flip-move": "static-1.72"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30380",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.54715",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8071",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11528",
  "I18n": "/I18n/static-7.1633",
  "quartz": "/quartz/static-1.7097",
  "quartz-config": "/quartz-config/static-1.875",
  "quartz-core": "/quartz-core/static-1.6316",
  "react-dlb": "/react-dlb/static-1.80",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.804",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.54702",
  "feedback-utils": "/feedback-utils/static-1.54706",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4518",
  "forms-utils-lib": "/forms-utils-lib/static-1.12683",
  "foundations-assets": "/foundations-assets/static-1.4924",
  "foundations-components": "/foundations-components/static-1.8034",
  "foundations-theming": "/foundations-theming/static-1.4479",
  "hub-http": "/hub-http/static-1.6277",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyle": "/HubStyle/static-2.11835",
  "icons": "/icons/static-2.650",
  "immutable": "/immutable/static-2.79",
  "quick-fetch": "/quick-fetch/static-1.3959",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.187",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16733",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5385",
  "react-virtualized": "/react-virtualized/static-2.100",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.488",
  "tinymce-plugins": "/tinymce-plugins/static-1.57630",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1165",
  "UIComponents": "/UIComponents/static-3.8474",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3441",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3374",
  "quartz-webpack": "/quartz-webpack/static-1.3321",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2195",
  "property-description-translator": "/property-description-translator/static-1.3897",
  "HeadJS": "/HeadJS/static-2.765",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3182",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.222",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4380",
  "jasmine-runner": "/jasmine-runner/static-1.6518",
  "dispatcher": "/dispatcher/static-1.137",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.839",
  "hubspotter-http": "/hubspotter-http/static-1.4692",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.539",
  "module-federation": "/module-federation/static-1.24",
  "quartz-auth": "/quartz-auth/static-1.772",
  "quartz-head": "/quartz-head/static-1.762",
  "quartz-i18n": "/quartz-i18n/static-1.772",
  "quartz-routing": "/quartz-routing/static-1.527",
  "quartz-test": "/quartz-test/static-1.772",
  "quartz-tracking": "/quartz-tracking/static-1.476",
  "trellis-components": "/trellis-components/static-1.2099",
  "ui-fonts": "/ui-fonts/static-1.790",
  "usage-tracker-container": "/usage-tracker-container/static-1.7394",
  "usage-tracker-core": "/usage-tracker-core/static-1.7254",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.157",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7303",
  "reference-resolvers": "/reference-resolvers/static-1.8226",
  "sanitize-text": "/sanitize-text/static-1.8197",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ReduxMessenger": "/ReduxMessenger/static-2.10419",
  "sanitize": "/sanitize/static-1.4531",
  "outpost": "/outpost/static-1.4230",
  "rpc-client-utils": "/rpc-client-utils/static-1.4707",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4303",
  "floating-ui": "/floating-ui/static-1.57",
  "hs-story-utils": "/hs-story-utils/static-1.9478",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.31",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2080",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2962",
  "foundations-theming-base": "/foundations-theming-base/static-1.3464",
  "stylex": "/stylex/static-1.34",
  "hs-locale-management": "/hs-locale-management/static-1.122",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.7",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9100",
  "atom": "/atom/static-1.5129",
  "codemirror": "/codemirror/static-5.96",
  "content-assistance-lib": "/content-assistance-lib/static-1.7834",
  "ContentUtils": "/ContentUtils/static-1.68520",
  "data-token-picker": "/data-token-picker/static-1.16500",
  "file-manager-components": "/file-manager-components/static-1.23762",
  "FileManagerCore": "/FileManagerCore/static-1.39261",
  "FileManagerLib": "/FileManagerLib/static-1.39402",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7981",
  "hub-http-contrib": "/hub-http-contrib/static-1.3096",
  "interframe": "/interframe/static-3.4814",
  "layout-dnd-components": "/layout-dnd-components/static-1.12549",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11524",
  "property-translator": "/property-translator/static-1.5453",
  "react-codemirror": "/react-codemirror/static-1.10682",
  "react-colorpicker": "/react-colorpicker/static-2.10263",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8152",
  "rich-text-lib": "/rich-text-lib/static-1.19919",
  "tinymce-data": "/tinymce-data/static-1.40601",
  "tinymce-themes": "/tinymce-themes/static-1.56486",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9941",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5265",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15487",
  "bender-build-tools": "/bender-build-tools/static-1.3254",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10091",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10089",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5090",
  "base-ui": "/base-ui/static-1.12",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.988",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.117",
  "chirp-fetch": "/chirp-fetch/static-1.1942",
  "chatspot-core": "/chatspot-core/static-1.21532",
  "copilot-toolkit": "/copilot-toolkit/static-1.11275",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13087",
  "data-fetching-client": "/data-fetching-client/static-1.9719",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4815",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8758",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28707",
  "usage-tracker": "/usage-tracker/static-1.7404",
  "cms-field-types": "/cms-field-types/static-1.4867",
  "content-icons-ui": "/content-icons-ui/static-1.2239",
  "integrations-lib": "/integrations-lib/static-1.16333",
  "customer-data-objects": "/customer-data-objects/static-1.7732",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4706",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.87",
  "graphql": "/graphql/static-1.83",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4208",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9115",
  "video-components-external": "/video-components-external/static-1.11465",
  "video-data-lib": "/video-data-lib/static-1.35123",
  "audio-components": "/audio-components/static-1.5993",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29395",
  "FileManagerImages": "/FileManagerImages/static-1.36913",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1059",
  "html-to-image": "/html-to-image/static-1.55",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "salesImages": "/salesImages/static-1.526",
  "ui-universal-auth": "/ui-universal-auth/static-1.9044",
  "urlinator": "/urlinator/static-1.4592",
  "video-components": "/video-components/static-1.13467",
  "video-embed": "/video-embed/static-1.35957",
  "ts-schema": "/ts-schema/static-1.4121",
  "ContentData": "/ContentData/static-1.68595",
  "layout-data-lib": "/layout-data-lib/static-1.9849",
  "react-dnd-compat": "/react-dnd-compat/static-1.4668",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1596",
  "external-options-client-types": "/external-options-client-types/static-1.4199",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6943",
  "hs-promise-utils": "/hs-promise-utils/static-1.5646",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3886",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9100",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3121",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11206",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.840",
  "magpie-lib": "/magpie-lib/static-1.5587",
  "magpie-types": "/magpie-types/static-1.5047",
  "simple-logging-lib": "/simple-logging-lib/static-1.3105",
  "avatar-components": "/avatar-components/static-1.2553",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9880",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6634",
  "flux-actions": "/flux-actions/static-1.341",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4932",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13748",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5659",
  "laboratory-lib": "/laboratory-lib/static-3.7210",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7836",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10266",
  "unified-auth": "/unified-auth/static-1.558",
  "navigation-messaging": "/navigation-messaging/static-1.7493",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12532",
  "content-media-compositions": "/content-media-compositions/static-2.16539",
  "idb-keyval": "/idb-keyval/static-1.45",
  "media-bridge-lib": "/media-bridge-lib/static-1.19017",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.840",
  "social-insights-client-types": "/social-insights-client-types/static-1.22240",
  "advanced-menus-core": "/advanced-menus-core/static-1.15212",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12147",
  "ExportDialog": "/ExportDialog/static-6.10440",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34189",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3839",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4181",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.62",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4046",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6848",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3627",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3733",
  "persist-promise": "/persist-promise/static-1.3753",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5517",
  "breeze-engine-core": "/breeze-engine-core/static-1.118",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.80",
  "reactive-lib": "/reactive-lib/static-1.778",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.391",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3072",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.52",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.390",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.525",
  "slack-ui-library": "/slack-ui-library/static-1.10446",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3785",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15211",
  "simple-menus-lib": "/simple-menus-lib/static-1.16728",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3631",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9413",
  "react-flip-move": "/react-flip-move/static-1.72"
}
};
